import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '../models';

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: User) => void;
  setUser: (user: User) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      
      setAuth: (token: string, user: User) => 
        set({ 
          token, 
          user, 
          isAuthenticated: true 
        }),
      
      setUser: (user: User) => 
        set((state) => ({ 
          ...state, 
          user 
        })),
      
      clearAuth: () => 
        set({ 
          token: null, 
          user: null, 
          isAuthenticated: false 
        }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        token: state.token, 
        user: state.user, 
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
);
